import {
  INIT_FORM,
  SET_FORM_ERRORS,
  SET_FIELD_ERRORS,
  FOCUS_FIELD,
  TOUCH_FIELD,
  UNTOUCH_FIELD,
  TOUCH_ALL_FIELDS,
  UPDATE_FIELD,

  // Stepped Form
  INIT_STEPPED_FORM,
  START_UPDATING,
  STOP_UPDATING,
  GOTO_PREV_STEP,
  GOTO_NEXT_STEP
} from './constants'
import { IField } from './types'

export function initForm(formId: string, initialState: { [key: string]: IField }) {
  return {
    type: INIT_FORM,
    payload: {
      id: formId,
      initialState: initialState
    }
  }
}

export function setFormErrors(
  formId: string,
  formErrors: { [key: string]: string | string[] } | null
) {
  return {
    type: SET_FORM_ERRORS,
    payload: {
      id: formId,
      errors: formErrors
    }
  }
}

export function setFieldErrors(
  formId: string,
  fieldErrors: { [key: string]: string | string[] } | null
) {
  return {
    type: SET_FIELD_ERRORS,
    payload: {
      id: formId,
      errors: fieldErrors
    }
  }
}

export function focusField(formId: string, fieldName: string) {
  return {
    type: FOCUS_FIELD,
    payload: {
      id: formId,
      name: fieldName
    }
  }
}

export function touchField(formId: string, fieldName: string) {
  return {
    type: TOUCH_FIELD,
    payload: {
      id: formId,
      name: fieldName
    }
  }
}

export function untouchField(formId: string, fieldName: string) {
  return {
    type: UNTOUCH_FIELD,
    payload: {
      id: formId,
      name: fieldName
    }
  }
}

export function touchAllFields(formId: string, fields?: string[]) {
  return {
    type: TOUCH_ALL_FIELDS,
    payload: {
      id: formId,
      fields: fields
    }
  }
}

export function updateField(formId: string, fieldName: string, fieldValue: any) {
  if (String(fieldValue).trim().length < 1) {
    fieldValue = ''
  }

  return {
    type: UPDATE_FIELD,
    payload: {
      id: formId,
      name: fieldName,
      value: fieldValue
    }
  }
}

// Stepped Form

export function initSteppedForm(formId: string, initialState: { [key: string]: IField }) {
  return {
    type: INIT_STEPPED_FORM,
    payload: {
      id: formId,
      initialState: initialState
    }
  }
}

export function startUpdating(formId: string) {
  return {
    type: START_UPDATING,
    payload: {
      id: formId
    }
  }
}

export function stopUpdating(formId: string) {
  return {
    type: STOP_UPDATING,
    payload: {
      id: formId
    }
  }
}

export function gotoPrevStep(formId: string) {
  return {
    type: GOTO_PREV_STEP,
    payload: {
      id: formId
    }
  }
}

export function gotoNextStep(formId: string) {
  return {
    type: GOTO_NEXT_STEP,
    payload: {
      id: formId
    }
  }
}
